import type { BackendMcpIneligibleReason, BackendOAuthConsentStopReason } from 'src/types/backend';

const STOP_REASON_MESSAGES: Record<BackendOAuthConsentStopReason, string> = {
  no_workspace: 'You don’t have a workspace you can connect. Ask your account admin for access.',
  plan_required: 'Connecting AI tools to Anyword needs a paid plan.',
  feature_not_enabled: 'Connecting AI tools isn’t available for your account yet.',
};

const INELIGIBLE_REASON_LABELS: Record<BackendMcpIneligibleReason, string> = {
  plan_required: 'Needs a paid plan',
  feature_not_enabled: 'Not available yet',
};

export const getOAuthConsentStopReasonMessage = (reason: BackendOAuthConsentStopReason): string =>
  STOP_REASON_MESSAGES[reason];

export const getMcpIneligibleReasonLabel = (reason: BackendMcpIneligibleReason): string =>
  INELIGIBLE_REASON_LABELS[reason];
